enum TaskParameterTypeEnum {
  /**Статус */
  Status = 0,
  /**Приоритет */
  Priority = 1,
  /**Тег */
  Tag = 2,
  /**Тип */
  Type = 3,
  /**Сложность */
  Difficulty = 4,
}
export { TaskParameterTypeEnum };
